import React, { FunctionComponent } from 'react'

import { LinearGradient } from 'expo-linear-gradient'
import styled, { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

const LinearGradientStyled = styled(LinearGradient)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
})

export const GradientHeader: FunctionComponent = () => {
  const { colors } = useTheme() as ThemeType

  return (
    <LinearGradientStyled colors={[colors.gradientHeaderStart, colors.gradientHeaderEnd]} start={[0, 0]} end={[0, 1]} />
  )
}
